import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import PasswordInput from '../components/PasswordInput';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export default function Login() {
  const [email, setEmail] = useState('admin@example.com');
  const [password, setPassword] = useState('Admin123!');
  const [message, setMessage] = useState<string | null>(null);
  const navigate = useNavigate();

  async function loginSession(e: React.FormEvent) {
    e.preventDefault();
    setMessage(null);
    try {
      const res = await fetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      if (!res.ok) throw new Error('Invalid credentials');
      await res.json();
      navigate('/');
    } catch (err: unknown) {
      setMessage(err instanceof Error ? err.message : 'Login failed');
    }
  }

  return (
    <AuthLayout title="Sign in">
      <form className="space-y-4" onSubmit={loginSession}>
        <div className="grid gap-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </div>
        <div className="grid gap-2">
          <Label htmlFor="password">Password</Label>
          <PasswordInput
            id="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </div>
        <Button type="submit" className="w-full">Login</Button>
      </form>
      <div className="mt-3 text-right">
        <a href="/forgot" className="text-sm text-primary underline-offset-4 hover:underline">Forgot password?</a>
      </div>
      {message && <p className="mt-4 text-sm text-destructive">{message}</p>}
    </AuthLayout>
  );
}

